import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionService } from 'src/app/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AwsEvaluationsService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id': 'apliclientesksks',
      'client-hash': 'apliclientesksks',
      Auth: this.sessionService.token,
    }),
  };

  dependencyEvaluationPendingPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/user/dependencyEvaluationPendingPanel`, body , this.httpOptions);
  }

  listRequestEvaluationsPanelPagination(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listRequestEvaluationsPanelPagination`, body , this.httpOptions);
  }

  listRequestEvaluationsPanelGraphic(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listRequestEvaluationsPanelGraphic`, body , this.httpOptions);
  }

  notificationPendingEvaluations(body){
    return this.http.post(`${environment.baseUrlAPI}/company/notificationPendingEvaluations`, body , this.httpOptions);
  }

  usersFilterCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/usersFilterCompany`, body , this.httpOptions);
  }

  inviteUsersRequestMultipleCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/inviteUsersRequestMultipleCompany`, body , this.httpOptions);
  }

  usersToRequestUniqueCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/usersToRequestUniqueCompany`, body , this.httpOptions);
  }

  deleteEvaluationRequestCompany(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/company/deleteEvaluationRequestCompany`, httpOptionsTemp);
  }

  inviteUsersRequestSingleCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/inviteUsersRequestSingleCompany`, body , this.httpOptions);
  }

  dependencyEvaluationPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/user/dependencyEvaluationPanel`, body , this.httpOptions);
  }

  listEvaluationsPanelPagination(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listEvaluationsPanelPagination`, body , this.httpOptions);
  }

  listEvaluationsPanelGraphic(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listEvaluationsPanelGraphic`, body , this.httpOptions);
  }

  evaluateCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/evaluateCompany`, body , this.httpOptions);
  }

  inviteToEvaluateCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/inviteToEvaluateCompany`, body , this.httpOptions);
  }

  listEvaluationGuideLineCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listEvaluationGuideLineCompany`, body , this.httpOptions);
  }

  evaluationGuideLineCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/evaluationGuideLineCompany`, body , this.httpOptions);
  }

  deleteEvaluationGuideLineCompany(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/user/deleteEvaluationGuideLineCompany`, httpOptionsTemp);
  }

  exportEvaluationsPanelXlsx(body){
    return this.http.post(`${environment.baseUrlAPI}/user/exportEvaluationsPanelXlsx`, body , this.httpOptions);
  }

  observedEvaluation(body){
    return this.http.post(`${environment.baseUrlAPI}/user/observedEvaluation`, body , this.httpOptions);
  }

  updateCertifyEvaluation(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateCertifyEvaluation`, body , this.httpOptions);
  }

  updateStateEvaluation(body){
    return this.http.post(`${environment.baseUrlAPI}/user/updateStateEvaluation`, body , this.httpOptions);
  }


  //new 

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    }),
  };

  evaluationPanelDependency(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/dependency`, body , this.httpOptionsNew);
  }

  evaluationPanelDependencyDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/dependencyDetail`, body , this.httpOptionsNew);
  }

  evaluationPanelEvaluate(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/evaluate`, body , this.httpOptionsNew);
  }

  evaluationPanelFilterReferenceType(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/filterReferenceType`, body , this.httpOptionsNew);
  }

  evaluationPanelPagination(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/pagination`, body , this.httpOptionsNew);
  }

  evaluationPanelGraphic(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/graphic`, body , this.httpOptionsNew);
  }

  evaluationPanelGraphicSuppliers(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/graphicSuppliers`, body , this.httpOptionsNew);
  }

  evaluationPanelDownload(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/download`, body , this.httpOptionsNew);
  }

  evaluationDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/evaluationDetail`, body , this.httpOptionsNew);
  }

  evaluationObserve(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/observe`, body , this.httpOptionsNew);
  }

  evaluationRemove(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/remove`, body , this.httpOptionsNew);
  }

  evaluationUpdateState(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/updateState`, body , this.httpOptionsNew);
  }

  evaluationUpdateVerified(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/updateVerified`, body , this.httpOptionsNew);
  }

  evaluationPanelInvite(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/invite`, body , this.httpOptionsNew);
  }

  evaluationDownloadWord(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/downloadWord`, body , this.httpOptionsNew);
  }

  evaluationManagementDependency(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/dependency`, body , this.httpOptionsNew);
  }

  evaluationManagementPagination(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/pagination`, body , this.httpOptionsNew);
  }

  evaluationManagementGraphic(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/graphic`, body , this.httpOptionsNew);
  }

  evaluationManagementNotifyAll(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/notifyAll`, body , this.httpOptionsNew);
  }

  evaluationManagementNotifySelected(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/notifySelected`, body , this.httpOptionsNew);
  }

  evaluationManagementRequestDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/requestDetail`, body , this.httpOptionsNew);
  }
  evaluationManagementDeleteRequest(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/evaluation-management/deleteRequest`, httpOptionsTemp);
  }

  evaluationManagementInviteSingleRequest(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/inviteSingleRequest`, body , this.httpOptionsNew);
  }

  evaluationManagementInviteMultipleRequest(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/inviteMultipleRequest`, body , this.httpOptionsNew);
  }

  //gestion de evaluaciones

  evaluationManagementDependencyAccessPanel(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/dependencyAccessPanel`, body , this.httpOptionsNew);
  }

  evaluationManagementPendingRequests(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/pendingRequests`, body , this.httpOptionsNew);
  }

  evaluationManagementPendingRequestDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/pendingRequestDetail`, body , this.httpOptionsNew);
  }

  evaluationManagementEvaluateSingleOrMultipleRequest(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/evaluateSingleOrMultipleRequest`, body , this.httpOptionsNew);
  }

  evaluationManagementEvaluateUnifiedRequest(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/evaluateUnifiedRequest`, body , this.httpOptionsNew);
  }

  evaluationManagementEvaluatedEvaluations(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/evaluatedEvaluations`, body , this.httpOptionsNew);
  }

  evaluationManagementEvaluationDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/evaluationDetail`, body , this.httpOptionsNew);
  }

  evaluationManagementObservedEvaluations(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/observedEvaluations`, body , this.httpOptionsNew);
  }

  evaluationManagementEvaluateObserved(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-management/evaluateObserved`, body , this.httpOptionsNew);
  }

  evaluationPanelCreateComment(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/evaluation-panel/createComment`, body , this.httpOptionsNew);
  }
  
  evaluationPanelSupplierNotConformities(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/supplierNotConformities`, body , this.httpOptionsNew);
  }

  evaluationPanelSupplierNotConformityDetail(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/supplierNotConformityDetail`, body , this.httpOptionsNew);
  }

  evaluationPanelNotify(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/evaluation-panel/notify`, body , this.httpOptionsNew);
  }

  //
  supplierNetworkContacts(body){
    return this.http.post(`${environment.baseUrlAPI}/company/quoteManagement/prequalification/supplierNetwork/contacts`, body , this.httpOptions);
  }

  supplierAddContacts(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplier/addContacts`, body, this.httpOptions); 
  }

  updateSupplierContactCompanyShippingRequest(body){
    return this.http.post(`${environment.baseUrlAPI}/company/supplier/addContacts`, body , this.httpOptions);
  }
}


